import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Nav from "../Components/Nav/Nav";
import Login from "./Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminMenu from "../Components/Admin/AdminMenu";
import AdminFormHeader from "../Components/Admin/AdminFormHeader";
import KnowledgeMenu from "../Components/Knowledge/knowledgeMenu";
import RequestKnowledgeList from "../Components/Knowledge/RequestKnowledgeList";
import { getRequestKnowledge } from "../actions/requestKnowledge";

const AdminKnowledgeAssign = () => {
  const userData = useSelector((state) => state.userReducer);
  const knowledgeRequest = useSelector((state) => state.requestKnowledgeReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRequestKnowledge());
  }, [dispatch]);

  const requests = useMemo(
    () =>
      Object.values(knowledgeRequest).filter(
        (request) => request.requestStatus === "1"
      ),
    [knowledgeRequest]
  );

  return (
    <>
      <ToastContainer />
      {userData.isAdmin || userData.isReferent ? (
        <>
          <Nav />
          <div className="mainContainer">
            <AdminMenu />
            <div className="centerBlock_admin">
              <AdminFormHeader
                title="Tutoriels assignés"
                subtitle="Demandes de tutoriels en cours de traitement."
              />
              <KnowledgeMenu active="assignee" />
              <RequestKnowledgeList
                requests={requests}
                emptyLabel="Aucune demande assignée pour le moment."
              />
            </div>
          </div>
        </>
      ) : (
        <Login />
      )}
    </>
  );
};

export default AdminKnowledgeAssign;
